function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { defineComponent, openBlock, createElementBlock, normalizeClass, unref, createElementVNode, withKeys, withModifiers, renderSlot, createTextVNode, toDisplayString, createVNode, withCtx, withDirectives, vShow } from 'vue';
import _CollapseTransition from '../../collapse-transition/index.mjs';
import { ElIcon } from '../../icon/index.mjs';
import { ArrowRight } from '@element-plus/icons-vue';
import { collapseItemProps } from './collapse-item.mjs';
import { useCollapseItem, useCollapseItemDOM } from './use-collapse-item.mjs';
import _export_sfc from '../../../_virtual/plugin-vue_export-helper.mjs';
const _hoisted_1 = ["id", "aria-expanded", "aria-controls", "aria-describedby", "tabindex"];
const _hoisted_2 = ["id", "aria-hidden", "aria-labelledby"];
const __default__ = defineComponent({
  name: "ElCollapseItem"
});
const _sfc_main = /* @__PURE__ */defineComponent(_objectSpread(_objectSpread({}, __default__), {}, {
  props: collapseItemProps,
  setup(__props, _ref) {
    let expose = _ref.expose;
    const props = __props;
    const _useCollapseItem = useCollapseItem(props),
      focusing = _useCollapseItem.focusing,
      id = _useCollapseItem.id,
      isActive = _useCollapseItem.isActive,
      handleFocus = _useCollapseItem.handleFocus,
      handleHeaderClick = _useCollapseItem.handleHeaderClick,
      handleEnterClick = _useCollapseItem.handleEnterClick;
    const _useCollapseItemDOM = useCollapseItemDOM(props, {
        focusing,
        isActive,
        id
      }),
      arrowKls = _useCollapseItemDOM.arrowKls,
      headKls = _useCollapseItemDOM.headKls,
      rootKls = _useCollapseItemDOM.rootKls,
      itemWrapperKls = _useCollapseItemDOM.itemWrapperKls,
      itemContentKls = _useCollapseItemDOM.itemContentKls,
      scopedContentId = _useCollapseItemDOM.scopedContentId,
      scopedHeadId = _useCollapseItemDOM.scopedHeadId;
    expose({
      isActive
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(unref(rootKls))
      }, [createElementVNode("button", {
        id: unref(scopedHeadId),
        class: normalizeClass(unref(headKls)),
        "aria-expanded": unref(isActive),
        "aria-controls": unref(scopedContentId),
        "aria-describedby": unref(scopedContentId),
        tabindex: _ctx.disabled ? -1 : 0,
        type: "button",
        onClick: _cache[0] || (_cache[0] = function () {
          return unref(handleHeaderClick) && unref(handleHeaderClick)(...arguments);
        }),
        onKeydown: _cache[1] || (_cache[1] = withKeys(withModifiers(function () {
          return unref(handleEnterClick) && unref(handleEnterClick)(...arguments);
        }, ["stop", "prevent"]), ["space", "enter"])),
        onFocus: _cache[2] || (_cache[2] = function () {
          return unref(handleFocus) && unref(handleFocus)(...arguments);
        }),
        onBlur: _cache[3] || (_cache[3] = $event => focusing.value = false)
      }, [renderSlot(_ctx.$slots, "title", {}, () => [createTextVNode(toDisplayString(_ctx.title), 1)]), createVNode(unref(ElIcon), {
        class: normalizeClass(unref(arrowKls))
      }, {
        default: withCtx(() => [createVNode(unref(ArrowRight))]),
        _: 1
      }, 8, ["class"])], 42, _hoisted_1), createVNode(unref(_CollapseTransition), null, {
        default: withCtx(() => [withDirectives(createElementVNode("div", {
          id: unref(scopedContentId),
          role: "region",
          class: normalizeClass(unref(itemWrapperKls)),
          "aria-hidden": !unref(isActive),
          "aria-labelledby": unref(scopedHeadId)
        }, [createElementVNode("div", {
          class: normalizeClass(unref(itemContentKls))
        }, [renderSlot(_ctx.$slots, "default")], 2)], 10, _hoisted_2), [[vShow, unref(isActive)]])]),
        _: 3
      })], 2);
    };
  }
}));
var CollapseItem = /* @__PURE__ */_export_sfc(_sfc_main, [["__file", "collapse-item.vue"]]);
export { CollapseItem as default };